import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable()
export class ForgotMfaService {
  constructor(private apiSvc: ApiService) {}

  forgotMfa(email: string) {
    const url = `users/restore/mfa`;
    const body = { email };
    return this.apiSvc.post(url, body, {}, false);
  }
}
